import {
  titlePartialColor,
  type widgetObject,
} from '../types/offsites-widget-v4.types';

export const parseWidgetObject = (
  widgetData: string,
  tabName: string,
  logger: CallableFunction,
): widgetObject | undefined => {
    try {
      const widgetObjectData = JSON.parse(widgetData);

      if (!Object.keys(widgetObjectData).length) return;

      return {
        data: widgetObjectData,
        tabName,
      };
    } catch {
      logger(
        'The off site widgets data object encountered problems while transforming the object',
      );

      return;
    }
};

export const getBackgroundImage = (
  mobileView: boolean,
  gridView: boolean,
  imageName: string,
  getAssetPath: CallableFunction,
): string => {
    const imageSuffix = mobileView || gridView ? '_small' : '';

    return getAssetPath(
      `./assets/offsites-assets/images/${imageName}${imageSuffix}.jpg`,
    );
};

export const setWidgetData = (
  isDashboard: boolean,
  widgetData: string | widgetObject,
  tabName: string,
  logger: CallableFunction,
): widgetObject =>
  isDashboard
    ? (widgetData as widgetObject)
    : parseWidgetObject(widgetData as string, tabName, logger);

export const setTitlePartColor = (color: string) => {
    switch (color) {
    case titlePartialColor.blue:
      return 'offsite-banner-content__title-colored--blue';
    case titlePartialColor.black:
      return 'offsite-banner-content__title-colored--black';
    default:
      return 'offsite-banner-content__title-colored--green';
    }
};
